<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Client Users</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button v-if="abilities.can('create', 'client-users')"
            icon="add"
            @click="addClientUser"
            color="danger"
            type="border"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-divider class="m-5" />

      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
          <span class="ml-12 p-2">Status: </span>
          <v-select
            class="filter ml-2"
            v-model="selected_user_status"
            :options="userStatusList"
            label="user_status"
          />
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="4"
          vs-xs="12"
        >
           <div class="p-1">
            <span>Search: </span>
          </div>

          <ClientUserAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchClientAndClientUser"
            :searchOn="'client_and_client_user'"
            @event-name="handleChildEvent"
          ></ClientUserAutocomplete>
          <vs-icon
            class="pl-5 pointer"
            icon="cancel"
            @click="resetClientUser"
            size="small"
          ></vs-icon>
           <vs-button
            class="ml-20"
            icon="refresh"
            @click="resetAll"
            color="primary"
            >Reset</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
          <span class="ml-20 p-2">Role: </span>
          <v-select
            class="filter ml-2"
            v-model="selected_role"
            label="role"
            :options="clientRoleTypes"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <v-select v-model="per_page" :options="size_per_page" />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
        
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
         

          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->
        </vs-col>
      </vs-row>

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="clientUsers"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="client_id">Client</vs-th>
          <vs-th sort-key="first_name">Full Name</vs-th>
          <vs-th sort-key="desk_phone">Desk Phone</vs-th>
          <vs-th sort-key="mobile">Mobile</vs-th>
          <vs-th sort-key="email">Email</vs-th>
          <vs-th sort-key="status">status</vs-th>
          <vs-th sort-key="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].client_id">
              {{ data[indextr].client_id }}
            </vs-td>
            <!-- <vs-td :data="data[indextr].roles">
              <template v-if="data[indextr].roles[0]">
                 {{ data[indextr].roles[0].role }}
              </template>
            </vs-td> -->
            <vs-td :data="data[indextr].first_name">
              {{ data[indextr].first_name + " " + data[indextr].surname }}
            </vs-td>

            <vs-td :data="data[indextr].desk_phone">
              {{ data[indextr].desk_phone }}
            </vs-td>
            <vs-td :data="data[indextr].mobile_no">
              {{ data[indextr].mobile_no }}
            </vs-td>
            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>
            <vs-td :data="data[indextr].user_status">
              {{ data[indextr].user_status }}
            </vs-td>
            <vs-td :data="data[indextr].actions">
              <vs-icon v-if="abilities.can('read', 'client-users')"
                class="ml-10 removeButton"
                @click="viewClientUser(data[indextr].id)"
                color="success"
                icon="visibility"
              ></vs-icon>
              <vs-icon v-if="abilities.can('update', 'client-users')"
                class="ml-10 removeButton"
                @click="editClientUser(data[indextr].id)"
                color="success"
                icon="edit"
              ></vs-icon>
              <vs-icon v-if="abilities.can('delete', 'client-users')"
                class="ml-10 removeButton"
                @click="confirmDeleteClientUser(data[indextr].id)"
                color="success"
                icon="delete"
              ></vs-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination
          :total="Math.ceil(total / per_page)"
          v-model="currentx"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleClientUserManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import ClientUserAutocomplete from "@/components/autocomplete/ClientUserAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data: () => ({
                            abilities : null,

    companySearchComponentKey: 0,
    selected: [],
    log: [],
    clientUsers: [],
    userStatusList: [],
    selected_user_status: "All",
    selected_role: "All",
    clientRoleTypes: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    }
  }),
  components: {
    ClientUserAutocomplete,
    "v-select": vSelect,
    moduleClientUserManagement,
    ClientAutocomplete
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    },
    selected_role: function(val) {
      if (val != "All") this.fetchClientUsersWithFilter();
    },
    selected_user_status: function(val) {
      if (val != "All") this.fetchClientUsersWithFilter();
    }
  },
  methods: {
    getClientManagers(clientId) {
      this.$store
        .dispatch("clientUsersManagement/getClientManagers", clientId)
        .then(res => {
          this.clientManagers = res.data;
          let self = this;
          self.clientUsers = self.clientManagers.filter(function(ele) {
            if (ele.client_id) {
              //get promise value
              self.showClientName(ele.client_id).then(function(data) {
                if (data) {
                  ele.client_id = data.data.company_name;
                }
              });
            } else {
              ele.client_id = null;
            }

            if (ele.user_status) {
              self.showStatusName(ele.user_status).then(function(data) {
                if (data) {
                  ele.user_status = data.data.user_status;
                }
              });
            } else {
              ele.user_status = null;
            }
            return ele;
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    showAssociatedClientUsers() {
      let selected_client = moduleClientManagement.state.clients.datas;
      this.getClientManagers(selected_client[0].id);
    },
    resetAll() {
      this.selected_user_status = "All";
      this.selected_role = "All";
      this.resetClientUser();
    },
    searchCompany(inputValue) {
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data = moduleClientManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchClientUsersWithFilter() {
      let filter = {};
      filter.status = this.selected_user_status;
      filter.role = this.selected_role;
      this.$store
        .dispatch("clientUsersManagement/fetchAllClientUsersWithFilter", filter)
        .then(res => {
          this.clientUsers = moduleClientUserManagement.state.client_users;
          let self = this;
          self.clientUsers = self.clientUsers.filter(function(ele) {
            if (ele.client_id) {
              //get promise value
              self.showClientName(ele.client_id).then(function(data) {
                if (data) {
                  ele.client_id = data.data.company_name;
                }
              });
            } else {
              ele.client_id = null;
            }
            if (ele.user_status) {
              self.showStatusName(ele.user_status).then(function(data) {
                if (data) {
                  ele.user_status = data.data.user_status;
                }
              });
            } else {
              ele.user_status = null;
            }
            return ele;
          });
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getClientRoleTypes() {
      this.$store
        .dispatch("clientUsersManagement/getClientRoleTypes")
        .then(res => {
          this.clientRoleTypes = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getClientUserStatus() {
      this.$store
        .dispatch("clientUsersManagement/getClientUserStatus")
        .then(res => {
          this.userStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    resetClientUser() {
      this.fetchClientUsers();
      this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      this.fetchClientUsers();
    },
    searchClientAndClientUser(inputValue) {
      return this.$store
        .dispatch("clientUsersManagement/searchClientAndClientUser", inputValue)
        .then(response => {
          if (response) {
            let data = moduleClientUserManagement.state.client_user;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].first_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].first_name +
                      " " +
                      data[property].surname +
                      " (Client User)",
                    type: "client_user"
                  });
                } 
                // else {
                //   mappedArray.push({
                //     id: data[property].id,
                //     name: data[property].company_name + " (Client)",
                //     type: "client"
                //   });
                // }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addClientUser() {
      this.$router.push({ path: "/client-user/add" });
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`);
    },
    viewClientUser(id) {
      this.$router.replace("/client-user/" + id);
    },
    editClientUser(id) {
      this.$router.replace("/client-user/edit/" + id);
    },
    handleChildEvent() {
      this.searchedclients = moduleClientManagement.state.searched_clients;
      this.clientUsers = moduleClientUserManagement.state.client_users.datas;

      if (typeof this.searchedclients.id != "undefined") {
        let selected_client = moduleClientManagement.state.searched_clients;
        this.getClientManagers(selected_client.id);
      } else {
        let self = this;
        self.clientUsers = moduleClientUserManagement.state.client_users.datas.filter(
          function(ele) {
            if (ele.client_id) {
              //get promise value
              self.showClientName(ele.client_id).then(function(data) {
                if (data) {
                  ele.client_id = data.data.company_name;
                }
              });
            } else {
              ele.client_id = null;
            }

            if (ele.user_status) {
              self.showStatusName(ele.user_status).then(function(data) {
                if (data) {
                  ele.user_status = data.data.user_status;
                }
              });
            } else {
              ele.user_status = null;
            }
            return ele;
          }
        );
      }
    },
    confirmDeleteClientUser(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete ClientUser`,
        accept: this.deleteClientUser,
        acceptText: "Delete"
      });
    },
    deleteClientUser() {
      this.$store
        .dispatch("clientUsersManagement/removeClientUser", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchClientUsers();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "ClientUser Deleted",
        text: "The User was successfully deleted"
      });
    },
    async showClientName(clientId) {
      let result = await this.$store
        .dispatch("clientsManagement/fetchClient", clientId)
        .then(res => {
          return res;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });

      return result;
    },
    async showStatusName(statusId) {
      let result = await this.$store
        .dispatch("clientUsersManagement/fetchStatus", statusId)
        .then(res => {
          return res;
        })
        .catch(err => {
          console.log(err);
        });

      return result;
    },
    fetchClientUsers() {
      this.$store
        .dispatch(
          "clientUsersManagement/fetchAllClientUsers",
          this.paginationAttr
        )
        .then(res => {
          let self = this;
          self.clientUsers = moduleClientUserManagement.state.client_users.datas.filter(
            function(ele) {
              if (ele.client_id) {
                //get promise value
                self.showClientName(ele.client_id).then(function(data) {
                  if (data) {
                    ele.client_id = data.data.company_name;
                  }
                });
              } else {
                ele.client_id = null;
              }

              if (ele.user_status) {
                self.showStatusName(ele.user_status).then(function(data) {
                  if (data) {
                    ele.user_status = data.data.user_status;
                  }
                });
              } else {
                ele.user_status = null;
              }
              return ele;
            }
          );
          this.total = moduleClientUserManagement.state.client_users.total;
          this.per_page =
            moduleClientUserManagement.state.client_users.per_page;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
    this.fetchClientUsers();
    this.getClientRoleTypes();
    this.getClientUserStatus();
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    }); 
    if (!moduleClientUserManagement.isRegistered) {
      this.$store.registerModule(
        "clientUsersManagement",
        moduleClientUserManagement
      );
      moduleClientUserManagement.isRegistered = true;
    }
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.searchClients {
  width: 600px;
  margin-right: 20px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.address_th {
  padding: 30px;
}

.filter {
  width: 300px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
